import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import App from './App.vue';
import globalVariable from "@/api/global_variable";
import 'url-search-params-polyfill'
import store from './store'

Vue.prototype.GLOBAL = globalVariable;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer)

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

import axios from 'axios'

Vue.prototype.$http = axios.create({
    baseURL: globalVariable.base_url + 'api'
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


